import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-non-appointed',
  templateUrl: './non-appointed.component.html',
  styleUrls: ['./non-appointed.component.scss']
})
export class NonAppointedComponent implements OnInit {

  brokerType: string;
  constructor() {

  }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

}
